const registerRemovingMemberFromGroup = () => {
  $(function () {
    const userForms = $('form.remove-member');
    const modalHandler = $('.modal');
    const dimmerHandler = $('.dimmer');

    userForms.each(function () {
      const form = $(this);

      form.on('submit', (e) => {
        e.preventDefault();

        modalHandler.find('#modal-member').html(form.data('member-name'));
        modalHandler.find('#modal-group').html(form.data('group-name'));

        modalHandler.data('current_form_id', form.attr('id'));
        modalHandler.modal('show');

        dimmerHandler.on('click', () => {
          modalHandler.trigger('close');
        });
      });
    });

    modalHandler.on('click', '.approve', () => {
      $(`#${modalHandler.data('current_form_id')}`)[0].submit();
    });

    modalHandler.on('click', '.cancel', () => {
      modalHandler.trigger('close');
    });
  });
};

const registerGroupDetails = () => {
  registerRemovingMemberFromGroup();
};

window.registerGroupDetails = registerGroupDetails;
